import React from "react";
import styled from "styled-components";
import anchoringBg from "../assets/anchoring bg.png";

const AboutContainer = styled.div`
  padding: 80px 0;
  background: #fafbff;

  @media (max-width: 1024px) {
    padding: 70px 0;
  }

  @media (max-width: 768px) {
    padding: 60px 0;
  }

  @media (max-width: 480px) {
    padding: 40px 0;
  }
`;

const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  margin-bottom: 3rem;

  @media (max-width: 1024px) {
    padding: 0 18px;
    margin-bottom: 2.5rem;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    padding: 0 12px;
    margin-bottom: 1.5rem;
  }
`;

const EstablishedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  background: rgba(0, 191, 255, 0.1);
  color: var(--primary-blue);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 2rem;
  border: 1px solid rgba(0, 191, 255, 0.2);
  box-shadow: var(--shadow-light);

  svg {
    margin-right: 0.5rem;
    width: 16px;
    height: 16px;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
    margin-bottom: 1.5rem;
    
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 1rem;

  @media (max-width: 1024px) {
    font-size: 2.2rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.75rem;
    margin-bottom: 0.75rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 1.1rem;
  color: var(--text-secondary);
  text-align: center;
  max-width: 600px;
  margin: 0 auto 3rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin: 0 auto 2.5rem;
    max-width: 500px;
  }

  @media (max-width: 480px) {
    font-size: 0.95rem;
    margin: 0 auto 2rem;
    line-height: 1.5;
  }
`;

const StoryCard = styled.div`
  background: rgba(0, 191, 255, 0.05);
  border-radius: 20px;
  padding: 3rem;
  position: relative;
  border: 1px solid rgba(0, 191, 255, 0.1);
  box-shadow: 0 2px 10px rgba(0, 191, 255, 0.1);

  @media (max-width: 1024px) {
    padding: 2.5rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
    border-radius: 15px;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
    border-radius: 12px;
  }
`;

const StoryIcon = styled.div`
  width: 60px;
  height: 60px;
  background: #00bfff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 191, 255, 0.1);

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 1.3rem;
    margin-bottom: 1.2rem;
  }

  @media (max-width: 480px) {
    width: 45px;
    height: 45px;
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
`;

const StoryTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 0.8rem;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
    margin-bottom: 0.7rem;
  }
`;

const StoryText = styled.p`
  color: var(--text-secondary);
  line-height: 1.7;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.95rem;
    line-height: 1.6;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

const MissionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 300px;
  gap: 3rem;
  align-items: start;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr auto 280px;
    gap: 2.5rem;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 2.5rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  @media (max-width: 480px) {
    gap: 1.5rem;
  }
`;

const MissionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--grid-gap-md);

  @media (max-width: 768px) {
    gap: var(--grid-gap-sm);
  }

  @media (max-width: 480px) {
    gap: 1.2rem;
  }
`;

const MissionItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;

  @media (max-width: 480px) {
    gap: 0.8rem;
  }
`;

const MissionIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  flex-shrink: 0;

  &.health {
    background: #00bfff;
  }
  &.social {
    background: #ff8c00;
  }
  &.empowerment {
    background: #e91e63;
  }
  &.employment {
    background: #0066cc;
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
`;

const MissionContent = styled.div`
  flex: 1;
`;

const MissionTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.05rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 0.4rem;
  }
`;

const MissionDescription = styled.p`
  color: var(--text-secondary);
  line-height: 1.6;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
    line-height: 1.4;
  }
`;


const LeadershipSection = styled.div`
  text-align: center;
`;

const LeadershipGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--grid-gap-xl);
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    gap: var(--grid-gap-lg);
    max-width: 700px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: var(--grid-gap-md);
    max-width: 500px;
  }

  @media (max-width: 480px) {
    gap: var(--grid-gap-sm);
    max-width: 400px;
  }
`;

const LeaderCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 3rem;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: var(--shadow-light);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid var(--light-gray);

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-medium);
  }

  @media (max-width: 1024px) {
    padding: 2.5rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
    border-radius: 15px;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
    border-radius: 12px;
  }
`;

const LeaderImage = styled.img`
  width: 220px;
  height: 220px;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  object-fit: cover;
  object-position: 50% 40%;
  border: 4px solid var(--primary-blue);
  box-shadow: var(--shadow-medium);

  @media (max-width: 1024px) {
    width: 200px;
    height: 200px;
    margin-bottom: 1.3rem;
  }

  @media (max-width: 768px) {
    width: 170px;
    height: 170px;
    margin-bottom: 1.2rem;
    border-width: 3px;
  }

  @media (max-width: 480px) {
    width: 140px;
    height: 140px;
    margin-bottom: 1rem;
    border-width: 3px;
  }
`;

const LeaderName = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 0.4rem;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
    margin-bottom: 0.3rem;
  }
`;

const LeaderTitle = styled.p`
  color: var(--text-secondary);
  font-weight: 500;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const About = () => {
  return (
    <AboutContainer>
      <Section>
        <div className="text-center">
          <EstablishedBadge>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z" fill="currentColor"/>
            </svg>
            Established April 14, 2021
          </EstablishedBadge>
          <SectionTitle>About ASKK International</SectionTitle>
          <SectionSubtitle>
            Pioneering women's health with innovative products and unwavering
            commitment to quality
          </SectionSubtitle>
        </div>

        <StoryCard>
          <StoryIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H18V17H20V19ZM20 15H18V13H20V15ZM20 11H18V9H20V11ZM16 19H14V17H16V19ZM16 15H14V13H16V15ZM16 11H14V9H16V11Z" fill="white"/>
            </svg>
          </StoryIcon>
          <StoryTitle>Our Story</StoryTitle>
          <StoryText>
            Ask International Group of Co was formed on 14 April 2021. The
            company deals in trading and direct selling of branded cosmetic
            products, beauty products, personal care products and sanitary
            napkins. The company has its own brand of sanitary pads. Which is
            much better and more useful than the products available in the
            normal market.
          </StoryText>
        </StoryCard>
      </Section>

      <Section>
        <SectionTitle>Our Mission</SectionTitle>
        <MissionGrid>
          <MissionList>
            <MissionItem>
              <MissionIcon className="health">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L10.91 8.26L12 2Z" fill="white"/>
                  <circle cx="12" cy="12" r="3" fill="white"/>
                </svg>
              </MissionIcon>
              <MissionContent>
                <MissionTitle>Health & Wellness</MissionTitle>
                <MissionDescription>
                  Keep women and girls in good health by keeping them away from
                  diseases
                </MissionDescription>
              </MissionContent>
            </MissionItem>

            <MissionItem>
              <MissionIcon className="social">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 4C18.21 4 20 5.79 20 8C20 10.21 18.21 12 16 12C13.79 12 12 10.21 12 8C12 5.79 13.79 4 16 4ZM16 14C18.67 14 22 15.34 22 18V20H10V18C10 15.34 13.33 14 16 14ZM8 4C10.21 4 12 5.79 12 8C12 10.21 10.21 12 8 12C5.79 12 4 10.21 4 8C4 5.79 5.79 4 8 4ZM8 14C10.67 14 14 15.34 14 18V20H2V18C2 15.34 5.33 14 8 14Z" fill="white"/>
                </svg>
              </MissionIcon>
              <MissionContent>
                <MissionTitle>Social Identity</MissionTitle>
                <MissionDescription>
                  Create their identity in society and help them move forward
                </MissionDescription>
              </MissionContent>
            </MissionItem>

            <MissionItem>
              <MissionIcon className="empowerment">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 5.5V7.5L12.5 7L10 8L7.5 7L5 7.5V5.5L-1 7V9L5 8L7.5 9L10 8L12.5 9L15 8L21 9ZM7.5 12L10 11L12.5 12L15 11L17.5 12L20 11V13L17.5 14L15 13L12.5 14L10 13L7.5 14L5 13V11L7.5 12Z" fill="white"/>
                </svg>
              </MissionIcon>
              <MissionContent>
                <MissionTitle>Women Empowerment</MissionTitle>
                <MissionDescription>
                  Make women/girls self-reliant, by women/girls
                </MissionDescription>
              </MissionContent>
            </MissionItem>

            <MissionItem>
              <MissionIcon className="employment">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 16V15H3L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V15H14V16H10ZM20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V12C2 13.1 2.9 14 4 14H20C21.1 14 22 13.1 22 12V9C22 7.9 21.1 7 20 7ZM14 7H10V5H14V7Z" fill="white"/>
                </svg>
              </MissionIcon>
              <MissionContent>
                <MissionTitle>Employment Generation</MissionTitle>
                <MissionDescription>
                  Provide employment opportunities and reduce unemployment
                </MissionDescription>
              </MissionContent>
            </MissionItem>
          </MissionList>
        </MissionGrid>
      </Section>

      <Section>
        <LeadershipSection>
          <SectionTitle>Our Leadership</SectionTitle>
          <SectionSubtitle>
            Meet the visionary leaders driving our mission forward
          </SectionSubtitle>

          <LeadershipGrid>
            <LeaderCard>
              <LeaderImage
                src={require("../assets/Rahul Kumar.jpg")}
                alt="Ajay Kumar"
              />
              <LeaderName>AJAY KUMAR</LeaderName>
              <LeaderTitle>
                Chairman of ASKK International Group of co
              </LeaderTitle>
            </LeaderCard>

            <LeaderCard>
              <LeaderImage
                src={require("../assets/Sachina Mam.jpg")}
                alt="Sachina Mam"
              />
              <LeaderName>SACHINA MAM</LeaderName>
              <LeaderTitle>
                Director of ASKK International Group of co
              </LeaderTitle>
            </LeaderCard>
          </LeadershipGrid>
        </LeadershipSection>
      </Section>
    </AboutContainer>
  );
};

export default About;
